import React from "react";
import { useTranslation } from "react-i18next";
import phoneImage from "../assets/images/Esportsec/EsportsRoundImgs/sportsdraftbannerroundimg.png";
import frnbbg from "../assets/images/sportsdraftbanner.png";

const SportsDraft: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="relative pt-16 px-4 overflow-hidden bg-[#070b28] pb-[100px] bg-no-repeat bg-contain bg-bottom w-full h-[80vh] flex justify-center items-center"
      style={{
        backgroundImage: `url(${frnbbg})`,
      }}
    >
      <div className="max-w-[1300px] px-4 sm:px-6 md:px-8 mx-auto pt-[60px]">

        {/* Two Column Section */}
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-10 sm:gap-8 md:gap-12 pt-20">
          {/* LEFT: Text Section */}
          <div className="text-left">
            <h3 className="text-[28px] sm:text-[36px] md:text-[40px] lg:text-[46px] font-bold text-[#ffffff] mb-4 font-proxima uppercase leading-tight">
              {t("sportsDraft.title")}
            </h3>

            <p className="text-[16px] sm:text-[17px] md:text-[18px] leading-[28px] sm:leading-[30px] text-white mb-6 font-proxima">
              {t("sportsDraft.description")}
            </p>
            <div className="mt-6 flex flex-wrap gap-4 items-center justify-start">
              <a
              id="btnPlayStore" 
                href="https://play.google.com/store/apps/details?id=com.gamerji.sportsdraft"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-[#070b28] text-white py-3 px-6 rounded-lg hover:bg-[#222] transition-all border border-white/20"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  width="25.16"
                  height="32"
                  className="fa-2x text-white mr-[2px]"
                >
                  <path
                    fill="currentColor"
                    d="M293.6 234.3L72.9 13 353.7 174.2 293.6 234.3zM15.3 0C2.3 6.8-6.4 19.2-6.4 35.3l0 441.3c0 16.1 8.7 28.5 21.7 35.3L271.9 255.9 15.3 0zM440.5 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM72.9 499L353.7 337.8 293.6 277.7 72.9 499z"
                  />
                </svg>

                <div className="text-left leading-none">
                  <p className="text-xs font-medium">Download from</p>
                  <p className="text-base font-bold">Play Store</p>
                </div>
              </a>

              <a
              id="btnAppStore" 
                href="https://apps.apple.com/in/app/gamerji-esports-gaming-app/id6749573390 "
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-[#070b28] text-white py-3 px-6 rounded-lg hover:bg-[#222] transition-all border border-white/20"
              >
                <i className="fa fa-apple fa-2x text-white mr-[2px]"></i>
                <div className="text-left leading-none">
                  <p className="text-xs font-medium">Download from</p>
                  <p className="text-base font-bold">App Store</p>
                </div>
              </a>
            </div>
          </div>
          {/* RIGHT: Image */}
          <div className="relative max-w-[600px] mx-auto lg:mx-0">
            <img
              src={phoneImage}
              alt="Phone Stats"
              className="w-full h-auto relative"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SportsDraft;
